import {PortalVueBase} from '@/view/PortalVueBase'
import {PortalPageView, TopBarNavigationTarget} from '@/view/View'

export default abstract class PortalPageBase extends PortalVueBase implements PortalPageView {

  abstract pageTitle: string

  get topBarNavigation(): TopBarNavigationTarget | null {
    return null
  }

  beforeRouteEnter(to: any, from: any, next: any) {
    next((vm: PortalPageView) => {
      const self = vm as PortalPageBase
      if (self.main.portal) self.main.portal.topBar.showPage(self)
    })
  }
}
